export const config = {
  LIGHTHOUSE_API_KEY: "d91a2407.843d85e8b3bd4ccf8319dd43437749d1",
};
